export default __webpack_public_path__ + "static/media/directionIcon.34a94473.png";